import BaseSelect from './BaseSelect';

export default function AsyncSelect({ ...rest }) {
    return <BaseSelect {...rest} async />;
}
